import { render } from "./TaskFolderList.vue?vue&type=template&id=742b5172"
import script from "./TaskFolderList.vue?vue&type=script&lang=js"
export * from "./TaskFolderList.vue?vue&type=script&lang=js"

import "./TaskFolderList.vue?vue&type=style&index=0&id=742b5172&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__